import { render, staticRenderFns } from "./ReplyInputBox.vue?vue&type=template&id=40793926&"
import script from "./ReplyInputBox.vue?vue&type=script&lang=js&"
export * from "./ReplyInputBox.vue?vue&type=script&lang=js&"
import style0 from "./ReplyInputBox.vue?vue&type=style&index=0&id=40793926&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports